import Image from '@commons/image/Image'
import { getProduct } from '@nespresso/catalog-sdk'
import AddToCartButton from '@commons/add-to-cart/AddToCartButton'
import { useEffect, useState } from 'preact/hooks'
import Price from '../price/Price'
import styles from './ProductDisplay.module.scss'

export default function ProductDisplay({ sku, hideATC = false }) {
    const [product, setProduct] = useState(undefined)
    useEffect(() => {
        async function fetchProduct() {
            const productData = await getProduct(sku)
            setProduct(productData)
        }

        if (sku) {
            fetchProduct()
        }
    }, [sku])

    const renderProductDetails = () => {
        // TODO: Hardcoded, change it with real data
        const heading = product?.name
        const description = product?.headline
        const price = product?.price

        return (
            <>
                {heading && <h3 className={styles.heading}>{heading}</h3>}
                {description && (
                    <p className={styles.description}>{description}</p>
                )}
                <Price priceDark price={price}></Price>
            </>
        )
    }
    const renderProductImage = () => {
        const src = product?.images.icon
        const alt = product?.name

        return <Image src={src} alt={alt} />
    }

    return (
        product && (
            <div className={styles.productDisplayWrapper}>
                <div className={styles.productDisplayWrapper__image}>
                    {renderProductImage()}
                </div>
                <div className={styles.productDisplayWrapper__details}>
                    {renderProductDetails()}
                </div>

                {!hideATC && (
                    <div className={styles.productDisplayWrapper__ATC}>
                        <AddToCartButton size="small" product={product} />
                    </div>
                )}
            </div>
        )
    )
}
